import {
    GET_CONTENT_FAILURE,
    GET_CONTENT_SUCCESS,
    SET_CONTENT
} from '../actions/content';
const initialState = {
    getContentSuccess: null,
    getContentFailure: null,
    content: {}
};

export default function contentReducer(state = initialState, action) {
    switch (action.type) {
        case SET_CONTENT:
            return {
                ...state,
                content: action.data
            };
        case GET_CONTENT_SUCCESS:
            return {
                ...state,
                getContentSuccess: true,
                getContentFailure: null,
                content: action.data
            };
        case GET_CONTENT_FAILURE:
            return {
                ...state,
                getContentSuccess: null,
                getContentFailure: true
            };
        default:
            return state;
    }
}